export default __webpack_public_path__ + "static/media/facebook.683a1087.svg";